export default __webpack_public_path__ + "static/media/Weissach.4cd2e00c.ttf";